import { SortEnum } from "@finway-group/shared/lib/consts"
import { type QueryParamsObject, type Vendor, type VendorTypeEnum } from "@finway-group/shared/lib/models"
import { typeHintFieldKey } from "@finway-group/shared/lib/models/queryParams/queryParams.types"
import { type UserCreditor } from "../../utils/vendor.utils"
import { type QueryParams } from "../consts"
import { getSortQueryObject } from "../query.utils"

export const defaultQueryParams: Readonly<Required<QueryParams>> = {
    page: 1,
    limit: 20,
    filter: {},
    search: "",
    sortOption: SortEnum.DESC,
    sortField: "createdAt",
    sortParams: [
        {
            sortField: "createdAt",
            sortOption: SortEnum.DESC,
        },
    ],
    [typeHintFieldKey]: {},
}

export const defaultQueryParamsObject: Readonly<QueryParamsObject> = {
    page: 1,
    limit: 20,
    ...getSortQueryObject([{ sortField: "createdAt", sortOption: SortEnum.DESC }]),
}

export const VENDOR_INFINITE_SCROLL_PAGE_LIMIT = 10

export type VendorDropdown = Pick<Vendor, "name" | "isApproved" | "creditorNumber" | "img" | "deleted" | "dateDeleted"> & { type: VendorTypeEnum.VENDOR; id: string }
export type UserCreditorDropDown = Pick<UserCreditor, "name" | "creditorNumber" | "img" | "deleted" | "dateDeleted"> & {
    type: VendorTypeEnum.USER
    id: string
}

export type CreditorDropdown = VendorDropdown | UserCreditorDropDown
